import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import * as organizationServices from '../../services';

export const useGetOrganizationUsers = (params, options) => {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetOrganizationUsers, params),
    () => organizationServices.getOrganizationUsers(params),
    options
  );
};
